import React, { useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { useParams } from 'react-router-dom'

import Select from 'components/Select'
import Checkbox from 'components/Checkbox'
import Button from 'components/Button'
import TrashBox from 'assets/icons/trash-box'
import DropdownIndicatorIconOpen from 'assets/icons/dropdown-indicator-opened24px'
import DropdownIndicatorIconClosed from 'assets/icons/dropdown-indicator-closed24px'
import { SpecieParameterToggleWrapper } from 'flow/SiteProposal/pages/Assessment/components/SpeciesDetails/SpeciesDetailsModal/style'
import CheckboxArrowIcon from 'assets/icons/checkbox-arrow-icon'
import CopyIcon from 'assets/icons/copy-icon'
import PasteIcon from 'assets/icons/paste-icon'
import {
  setCopyPayload,
  subscribe,
  getCopyPayload,
  subscribePasteUsed,
  setPasteUsed,
  getPasteUsed,
  setActiveDetail,
  getActiveDetail,
  subscribeActive,
  addActivePaste,
  clearActivePastes
} from './ecosystemCopyStore'
import { requestPressureCopyPaste } from 'api/monitoring'
import Modal from '../component/Modal'
import FlowRequestModal from 'components/FlowRequestModal'

import {
  DetailPanel,
  DetailSection,
  SectionTitle,
  TimingWrapper,
  RowActions,
  DetailHeaderRow,
  DetailColumns,
  TooltipBtnWrapper,
  TooltipBtnText
} from './style'
import CircleIcon from 'assets/icons/circle-icon'
import ProgressComplete from 'assets/icons/progress-complete'

const EcosystemAccordionContent = ({
  item,
  expandedSpeciesId,
  onToggleExpandedSpecies,
  scopeSelections,
  severitySelections,
  timingSelections,
  updateScope,
  updateSeverity,
  updateTiming,
  isScopeOptions,
  isSeverityOptions,
  isTimingOptions,
  getChecked,
  onToggleNode,
  getDepth,
  onOpenDetails,
  onClone,
  onDelete,
  isSpeciesView,
  isEditable
}) => {
  const params = useParams()
  if (isSpeciesView !== false) return null
  const baseDepth = getDepth ? getDepth(item) : item.depth || 0
  const nodesToRender = item.kind === 'species' ? [item] : item.children?.length ? item.children : [item]
  const [activeState, setActiveState] = useState(() => getActiveDetail())
  const instanceId = React.useRef(`ec-content-${Math.random().toString(36).slice(2)}`)
  const [copyPayload, setCopyPayloadState] = React.useState(() => getCopyPayload() || null)
  const [isSpeciesDeleteModal, setIsSpeciesDeleteModal] = React.useState(false)
  const [selectedItem, setSelectedItem] = React.useState(null)

  useEffect(() => {
    const unsub = subscribe((p) => setCopyPayloadState(p))
    return () => unsub()
  }, [])
  useEffect(() => {
    const unsub = subscribeActive((s) => setActiveState(s))
    return () => unsub()
  }, [])

  // Per-node row component so hooks are stable even when nodes array changes
  const NodeRow = ({ node }) => {
    const nodeDepth = getDepth ? getDepth(node) : node.depth || baseDepth + 1
    const scopeValue = scopeSelections[node.id]
    const severityValue = severitySelections[node.id]
    const timingValue = timingSelections[node.id]
    const foundScope =
      scopeValue && typeof scopeValue === 'object'
        ? scopeValue
        : isScopeOptions.find((opt) => (opt && (opt.value ?? opt.id)) === scopeValue)

    const scopeSelected = foundScope?.value === 999 ? null : foundScope || null
    const foundSeverity =
      severityValue && typeof severityValue === 'object'
        ? severityValue
        : isSeverityOptions.find((opt) => (opt && (opt.value ?? opt.id)) === severityValue)

    const severitySelected = foundSeverity?.value === 999 ? null : foundSeverity || null
    const timingSelected =
      timingValue && typeof timingValue === 'object'
        ? timingValue
        : isTimingOptions.find((opt) => (opt && (opt.value ?? opt.id)) === timingValue) || null
    const checked = getChecked ? Boolean(getChecked(node)) : Boolean(node && node.raw && node.raw.isChecked)
    const typeLabel = node.kind === 'ecosystem' ? 'Species' : node.type
    const isExpanded = expandedSpeciesId === node.id

    const isEmptyObject = copyPayload && typeof copyPayload === 'object' && Object.keys(copyPayload).length === 0
    const copiedId = copyPayload && copyPayload.copy_from_species
    const nodeSpeciesId = node?.raw?.historyId || node.id
    const isPasteDisabledSpecies = copyPayload
      ? Boolean(isEmptyObject || (copiedId && copiedId === nodeSpeciesId))
      : true

    const [isPasteDisabledBtn, setIsPasteDisabledBtn] = React.useState(isPasteDisabledSpecies || getPasteUsed())

    React.useEffect(() => {
      const unsub = subscribePasteUsed((v) => {
        setIsPasteDisabledBtn(Boolean(isPasteDisabledSpecies || v))
      })
      return () => unsub()
    }, [isPasteDisabledSpecies])

    React.useEffect(() => {
      try {
        setIsPasteDisabledBtn(Boolean(isPasteDisabledSpecies || getPasteUsed()))
      } catch (e) {}
    }, [isPasteDisabledSpecies, copyPayload])

    const isCopyActive =
      (copyPayload && copyPayload.copy_from_species === nodeSpeciesId) ||
      (activeState && activeState.copy && activeState.copy.id === node.id && activeState.copy.button === 'copy')

    // use parent's toggleChild from closure

    const handlePasteLocal = () => {
      const payload = getCopyPayload()
      if (!payload) return
      const pasteSpeciesId = node?.raw?.historyId || null
      const finalPayload = {
        ...payload,
        paste_to_species: [pasteSpeciesId],
        monitor_threats_id:
          node?.raw?.monitor_threats_trigger[0]?.monitor_threats_id ||
          node?.monitor_threats_id ||
          Number(item?.monitorThreatId) ||
          null,
        site_id: params.id || null,
        site_pressure_id: Number(params.pressureId) || null,
        filter_by: 1
      }
      updateScope?.(node.id, payload?.scope_id || null)
      updateSeverity(node.id, payload?.severity_id || null)
      updateTiming(node.id, payload?.site_threat_timing_id || null)
      ;['scope_id', 'severity_id', 'site_threat_timing_id'].forEach((k) => {
        if (k in finalPayload) delete finalPayload[k]
      })
      try {
        setPasteUsed(true)
      } catch (e) {}
      requestPressureCopyPaste(finalPayload)
        .then((response) => {
          console.log('EcosystemAccordionContent handlePaste response data: ', response)
        })
        .catch((error) => {
          console.error('EcosystemAccordionContent handlePaste error: ', error)
        })
        .finally(() => {
          try {
            setPasteUsed(false)
          } catch (e) {}
        })
    }

  //Check if scope, severity and timming valued are fill then Evaluated given freen color.
  const checkScopeValueRaw = scopeSelections?.[node.id] ?? node?.raw?.scope_id;
  const checkScopeValue = checkScopeValueRaw === 999 ? '' : checkScopeValueRaw;
  const checkSeverityValueRaw = severitySelections?.[node.id] ?? node?.raw?.severity_id;
  const checkSeverityValue = checkSeverityValueRaw === 999 ? '' : checkSeverityValueRaw;
  const checkTimingValue = timingSelections?.[node.id] ?? node?.raw?.site_threat_timing_id;
  const isEvaluated = Boolean(checkScopeValue && checkSeverityValue && checkTimingValue)

    return (
      <>
      <DetailPanel key={`${item.id || 'root'}-${node.id}`} style={{ margin: '4px 0 0px', backgroundColor: '#f6f6f6' }}>
        <DetailHeaderRow depth={nodeDepth} style={{ marginBottom: '0px', padding: '16px' }}>
          <div className="left">
            {nodeDepth > 0 && (
              <span>
                <CheckboxArrowIcon />
              </span>
            )}

            <Checkbox
              checked={checked}
              disabled={!isEditable}
              onChange={(event) => {
                event.stopPropagation()
                onToggleNode?.(node)
              }}
              label={
                <span className="species-label">
                  {/* <span className={`status-dot ${isEvaluated ? 'green' : 'blue'}`} /> */}
                  {isEvaluated ? <ProgressComplete /> : <CircleIcon />}
                  <span>
                    <em style={{display: "block"}}>{node.name}</em> {node.commonName}
                  </span>
                </span>
              }
            />
          </div>
          <div className="type-label"></div>
          <div className="expand-cell">
            <SpecieParameterToggleWrapper
              isActive={isExpanded}
              onClick={(event) => {
                event.stopPropagation()
                onToggleExpandedSpecies?.(node.id)
              }}
              style={{ cursor: 'pointer' }}
            >
              {isExpanded ? (
                <>
                  <FormattedMessage id="close" defaultMessage="Cclosee" />
                  <DropdownIndicatorIconOpen />
                </>
              ) : (
                <>
                  <FormattedMessage id="expand" defaultMessage="expand" />
                  <DropdownIndicatorIconClosed />
                </>
              )}
            </SpecieParameterToggleWrapper>
          </div>
          <RowActions>
            <TooltipBtnWrapper>
              <Button
                height="34px"
                marginTop="0"
                aria-label="Copy"
                title="Copy"
                style={{ width: '34px' }}
                isDisabled={!isEditable}
                onClick={(event) => {
                  event.stopPropagation()
                  const scopeValue = scopeSelections?.[node.id] || node?.raw?.scope_id
                  const severityValue = severitySelections?.[node.id] || node?.raw?.severity_id
                  const timingValue = timingSelections?.[node.id] || node?.raw?.site_threat_timing_id || threatTimmingId
                  const resolveId = (val) => {
                    if (!val && val !== 0) return ''
                    if (typeof val === 'object') return val.value ?? val.id ?? ''
                    return val
                  }
                  const payload = {
                    monitor_threats_id:
                      node?.raw?.monitor_threats_trigger?.[0]?.monitor_threats_id ||
                      node?.monitor_threats_id ||
                      Number(item?.monitorThreatId) ||
                      null,
                    copy_from_species: node?.raw?.historyId || node?.id || null,
                    site_id: params.id || null,
                    scope_id: resolveId(scopeValue),
                    severity_id: resolveId(severityValue),
                    site_threat_timing_id: resolveId(timingValue)
                  }

                  const existing = getCopyPayload()
                  if (
                    existing &&
                    existing.copy_from_species &&
                    existing.copy_from_species === payload.copy_from_species
                  ) {
                    try {
                      setCopyPayload(null)
                    } catch (e) {}
                    try {
                      setActiveDetail(null)
                    } catch (e) {}
                    try {
                      document.dispatchEvent(
                        new CustomEvent('ecosystem:buttonToggled', {
                          detail: {
                            scope: 'species',
                            id: node.id,
                            button: null,
                            taxon: item?.name,
                            source: instanceId.current
                          }
                        })
                      )
                    } catch (e) {}
                    return
                  }

                  const next = { id: node.id, button: 'copy' }
                  try {
                    setActiveDetail(next)
                  } catch (e) {}

                  setCopyPayload(payload)
                  try {
                    document.dispatchEvent(
                      new CustomEvent('ecosystem:buttonToggled', {
                        detail: {
                          scope: 'species',
                          id: node.id,
                          button: 'copy',
                          taxon: item?.name,
                          source: instanceId.current
                        }
                      })
                    )
                  } catch (e) {}
                  onClone?.(node)
                }}
                type={isCopyActive ? 'primary' : undefined}
              >
                <PasteIcon />
              </Button>
              <TooltipBtnText>
                <FormattedMessage id="copy" defaultMessage="copy" />
              </TooltipBtnText>
            </TooltipBtnWrapper>
            <TooltipBtnWrapper>
              <Button
                height="34px"
                marginTop="0"
                aria-label="Paste"
                title="Paste"
                style={{ width: '34px' }}
                isDisabled={!isEditable}
                onClick={(event) => {
                  if (isPasteDisabledBtn) return
                  event.stopPropagation()
                  const next = { id: node.id, button: 'paste' }
                  try {
                    addActivePaste(next)
                  } catch (e) {}
                  onOpenDetails?.(node)
                  handlePasteLocal()
                  try {
                    setPasteUsed(true)
                  } catch (e) {}
                }}
                type={
                  activeState && Array.isArray(activeState.pastes) && activeState.pastes.includes(node.id)
                    ? 'primary'
                    : undefined
                }
                disabled={isPasteDisabledBtn}
              >
                <CopyIcon />
              </Button>
              <TooltipBtnText>
                <FormattedMessage id="paste" defaultMessage="paste" />
              </TooltipBtnText>
            </TooltipBtnWrapper>
            <TooltipBtnWrapper>
              <Button
                type="disalbeBorder"
                height="34px"
                marginTop="0"
                isDisabled={!isEditable}
                onClick={(event) => {
                  event.stopPropagation()
                  setSelectedItem(node);
                  setIsSpeciesDeleteModal(true);
                }}
              >
                <TrashBox />
              </Button>
              <TooltipBtnText>
                <FormattedMessage id="delete" defaultMessage="delete" />
              </TooltipBtnText>
            </TooltipBtnWrapper>
          </RowActions>
        </DetailHeaderRow>

        {isExpanded && (
          <>
            <DetailColumns style={{ placeItems: 'left' }}>
              <DetailSection>
                <SectionTitle>
                  <FormattedMessage
                    id="onlyForSelectedSpeciesTitle"
                    defaultMessage="onlyForSelectedSpeciesTitle"
                  />
                </SectionTitle>
              </DetailSection>
            </DetailColumns>
            <DetailColumns style={{ display: 'flex', gap: 16, padding: '0px 130px' }}>
              <DetailSection style={{ flex: 1 }}>
                <SectionTitle>
                  <FormattedMessage id="ScopeOfThreatTitle" defaultMessage="ScopeOfThreatTitle" />
                </SectionTitle>
                <TimingWrapper style={{ maxWidth: '900px' }}>
                  <Select
                    placeholder="Please select"
                    value={scopeSelected}
                    disabled={!isEditable}
                    onChange={(value) => {
                      updateScope?.(node.id, value)
                      try {
                        setCopyPayload(null)
                        try {
                          setActiveDetail(null)
                        } catch (e) {}
                        try {
                          clearActivePastes()
                        } catch (e) {}
                        setIsPasteDisabledBtn(true)
                      } catch (e) {}
                    }}
                    options={isScopeOptions}
                  />
                </TimingWrapper>
              </DetailSection>
              <DetailSection style={{ flex: 1 }}>
                <SectionTitle>
                  <FormattedMessage id="SeverityOfThreatTitle" defaultMessage="SeverityOfThreatTitle" />
                </SectionTitle>
                <TimingWrapper>
                  <Select
                    placeholder="Please select"
                    value={severitySelected}
                    disabled={!isEditable}
                    onChange={(option) => {
                      updateSeverity(node.id, option)
                      try {
                        setCopyPayload(null)
                        try {
                          setActiveDetail(null)
                        } catch (e) {}
                        try {
                          clearActivePastes()
                        } catch (e) {}
                        setIsPasteDisabledBtn(true)
                      } catch (e) {}
                    }}
                    options={isSeverityOptions}
                  />
                </TimingWrapper>
              </DetailSection>
            </DetailColumns>
            <DetailSection style={{ padding: '0px 130px' }}>
              <SectionTitle>
                <FormattedMessage id="TimingOfThreatTitle" defaultMessage="TimingOfThreatTitle" />
              </SectionTitle>
              <TimingWrapper>
                <Select
                  placeholder="selectTiming"
                  value={timingSelected}
                  disabled={!isEditable}
                  onChange={(option) => {
                    updateTiming(node.id, option)
                    try {
                      setCopyPayload(null)
                      try {
                        setActiveDetail(null)
                      } catch (e) {}
                      try {
                        clearActivePastes()
                      } catch (e) {}
                      setIsPasteDisabledBtn(true)
                    } catch (e) {}
                  }}
                  options={isTimingOptions}
                />
              </TimingWrapper>
            </DetailSection>
          </>
        )}
      </DetailPanel>
      </>
    )
  }

  const handleDeleteSpecies = () => {
    if (selectedItem) {
      onDelete?.(selectedItem)
    }
    setIsSpeciesDeleteModal(false)
    setSelectedItem(null)
  }

  const handlePaste = (node) => {
    const payload = getCopyPayload()
    if (!payload) return
    const pasteSpeciesId = node?.raw?.historyId || null
    const finalPayload = {
      ...payload,
      paste_to_species: [pasteSpeciesId],
      monitor_threats_id:
        node?.raw?.monitor_threats_trigger[0]?.monitor_threats_id ||
        node?.monitor_threats_id ||
        Number(item?.monitorThreatId) ||
        null,
      site_id: params.id || null,
      site_pressure_id: Number(params.pressureId) || null,
      filter_by: 1
    }
    ;['scope_id', 'severity_id', 'site_threat_timing_id'].forEach((k) => {
      if (k in finalPayload) delete finalPayload[k]
    })
    //API call
    try {
      setPasteUsed(true)
    } catch (e) {}
    requestPressureCopyPaste(finalPayload)
      .then((response) => {
        //handle response
        console.log('EcosystemAccordionContent handlePaste response: ', response)
      })
      .catch((error) => {
        //handle error
        console.error('EcosystemAccordionContent handlePaste error: ', error)
      })
      .finally(() => {
        try {
          setPasteUsed(false)
        } catch (e) {}
      })
  }

  return (
    <>
      {nodesToRender.map((node) => (
        <NodeRow key={`${item.id || 'root'}-${node.id}`} node={node} />
      ))}
      <Modal
        width="496px"
        isOpen={isSpeciesDeleteModal}
        toggleModal={setIsSpeciesDeleteModal}
        modalTitleId={'taxonDeleteModalTitle'}
        sideModal={false}
      >
        <FlowRequestModal
          cancelHandler={() => {
            setIsSpeciesDeleteModal(false)
          }}
          confirmHandler={handleDeleteSpecies}
          confirmBtnText="yesDelete"
          text={<FormattedMessage id="removeSpeciesModalText" values={{ name: <b>{selectedItem?.name}</b> }} />}
          item={''}
          approve={false}
        />
      </Modal>
    </>
  )
}

export default EcosystemAccordionContent
